export const mapSrcLinks = [
    {
        country: "sg",
        link: "https://www.google.com/maps/d/embed?mid=11yCu7JQltIZcurMPlX3kByd0YoIXfF8&ehbc=2E312F"
    },
    {
        country: "id",
        link: "https://www.google.com/maps/d/embed?mid=1-TaKVRCE5wdhtjhSZRC1_BGb4HpQTdk&ehbc=2E312F"
    }
];
